import { useLocation } from '@reach/router';
import Container from 'components/Container';
import Faq from 'components/faqPage';
import Header from 'components/Header';
import Page from 'components/Page';
import IndexLayout from 'layouts';
import React from 'react';
import { graphql } from 'gatsby';
import { getQuery } from 'utils/query.utils';

const FaqPage: React.FC<SinglePageProps> = ({ data }) => {
  const { site, metadataJson } = data;
  const location = useLocation();
  const isEditorFaq = getQuery(location.search, 'editor');

  return (
    <IndexLayout
      metaData={{
        url: `${site.siteMetadata.url}/faq`,
        title: metadataJson.title,
        description: metadataJson.description,
      }}
    >
      <Header links={isEditorFaq ? [] : undefined} />
      <Page>
        <Container>
          <Faq />
        </Container>
      </Page>
    </IndexLayout>
  );
};

export default FaqPage;

export const query = graphql`
  query faqMetaData {
    site {
      siteMetadata {
        url
      }
    }
    metadataJson(page: { eq: "faq" }) {
      title
      description
    }
  }
`;
